import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
  withCredentials: true, // Habilitar el envío de cookies
});

axiosInstance.interceptors.response.use(
  response => response.data,
  error => {
    if (error.response?.status === 401) {
      localStorage.clear(); // Limpia datos en caso de error 401
      window.location.href = '/'; // Redirige al login
    } else if (error.response?.status === 403) {
      window.location.href = '/home'; // Redirige a la página principal
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
